import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const DatabasesIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Databases",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M24.99 2H7.03C4.87 2 3.12 3.76 3.11 5.92v20.21A3.923 3.923 0 0 0 7.03 30h12.36c.46 0 .87-.19 1.17-.49l7.85-7.85c.3-.3.48-.71.49-1.17V5.92c0-2.15-1.74-3.9-3.89-3.92ZM6.47 26.13V5.92c0-.31.25-.56.56-.56H25c.31 0 .56.25.56.56V17.7h-5.05a3.93 3.93 0 0 0-3.93 3.93v5.05H7.03a.56.56 0 0 1-.56-.56Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M25 28H7c-1.65 0-3-1.35-3-3v-8c0-.55.45-1 1-1s1 .45 1 1v8c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V7c0-.55-.45-1-1-1H13.41L5.7 13.71a.996.996 0 1 1-1.41-1.41l8-8.01A1 1 0 0 1 13 4h12c1.65 0 3 1.35 3 3v18c0 1.65-1.35 3-3 3"
      }), /*#__PURE__*/_jsx("path", {
        d: "M11 14H5c-.55 0-1-.45-1-1s.45-1 1-1h6c.55 0 1-.45 1-1V5c0-.55.45-1 1-1s1 .45 1 1v6c0 1.65-1.35 3-3 3"
      })]
    })
  }));
};